import * as RouteUtils from 'routes/route_utils.jsx';
import UserStore from 'stores/user_store.jsx';
import {browserHistory} from 'react-router/es6';


function preGetUser(nextState, replace, callback) {
    const user = UserStore.getCurrentUser();
    if (!user) {
        browserHistory.push('/?redirect_to=' + encodeURIComponent(nextState.location.pathname));
        return;
    }
    callback();
}

export default {
    path: 'talkto/:target',
    onEnter: preGetUser,
    getComponents: (location, callback) => {
        System.import('components/external/talkto.jsx').then(RouteUtils.importComponentSuccess(callback));
    }

};



// WEBPACK FOOTER //
// ./routes/route_talkto.jsx